import React, { ComponentProps } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import pathfinder from '@fiverr-private/pathfinder';
import { FiverrLogoHeader } from '../../icons';

interface HeaderProps {
    asLink?: boolean;
}
export const Header = ({ asLink }: HeaderProps) => {
    const linkProps: ComponentProps<typeof Stack> = asLink ? { as: 'a', href: pathfinder('jobs_page_jobs') } : {};

    return (
        <Stack as="header" alignItems="center" paddingY="5">
            <Stack height="27px" width="89px" alignItems="flexStart" {...linkProps}>
                <FiverrLogoHeader />
            </Stack>
        </Stack>
    );
};
